import React from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import FleetWebApi from "../Api/FleetWebApi";
import { NavLink } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
class UserDetails extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      userDetails: null,
      userId: props.userId,
    };
  }
  componentDidMount() {
    this._isMounted = true;
    FleetWebApi.getUserDetails(this.state.userId).then(
      (result) => {
        if (result.error) {
          if (this._isMounted) {
            this.setState({
              isLoaded: true,
              error: result.error,
            });
          }
        } else {
          if (this._isMounted) {
            this.setState({
              isLoaded: true,
              userDetails: result,
            });
          }
        }
      },
      (error) => {
        if (this._isMounted) {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      }
    );
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const { error, isLoaded, userDetails } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
    } else {
      return (
        <Paper>
          <Table classes={{ root: "reactivetable" }}>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Name
                </TableCell>
                <TableCell data-th="Name">
                  <NavLink
                    to={"/domain/" + this.state.userId}
                    className="Nav_link"
                  >
                    {userDetails.first} {userDetails.last} ({userDetails.name})
                  </NavLink>
                  <Tooltip title="AlertAQ" arrow placement="top">
                    <IconButton
                      size="small"
                      style={{ marginLeft: 5, padding: 1, verticalAlign: "middle" }}
                      href={`https://alertaq.com/quickportal?tab=Users&qID=${this.state.userId}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Open in AlertAQ"
                    >
                      <img src="/aq_logo.png" alt="AlertAQ" style={{ width: 16, height: 16, display: "block" }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  e-mail
                </TableCell>
                <TableCell data-th="E-Mail">{userDetails.email}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
      );
    }
  }
}
export default UserDetails;
